<kt-splash-screen *ngIf="loader"></kt-splash-screen>
<router-outlet></router-outlet>
<div id="mainUnityContainerWrapper">
	<div id="unityContainer"></div>
</div>
<div id="zmmtg-root"></div>